function saveDoc() {
  // Access jsPDF from the window object
    const { jsPDF } = window.jspdf;

  const margin = 30;

  const pages = document.querySelector('.pdf-content');
        console.log('pages ' + pages);

  html2canvas(pages, {scale: 2, useCORS: true }).then((ref) =>  {
      var img = ref.toDataURL("image/jpeg", 1);
      var doc = doc = new jsPDF({
      orientation: 'p',
      unit: 'pt',
      format: [pages.clientWidth + 30*2, pages.clientHeight + 100],
      putOnlyUsedFonts: true,
      compress: true
    });
    
    doc.addImage(img, 'JPEG', margin, 0, pages.clientWidth, pages.clientHeight, '', 'FAST');
    return doc;
  }).then((doc) => doc.save(document.title));
}